import {
  formatDate,
  formatRealtimeEstimateDate,
  isMealboxProduct,
} from "@chef/helpers";
import { language } from "@chef/constants";

import { OrdersQuery } from "../graphql/generated";

interface CampaignDetailsProps {
  campaignOrder: OrdersQuery["orders"][number];
  dayFormat?: string;
}

export const getCampaignDetails = ({
  campaignOrder,
  dayFormat = "eee",
}: CampaignDetailsProps) => {
  const campaignName =
    campaignOrder.orderLines
      .find((ol) => isMealboxProduct(ol.variation.product))
      ?.variation.product.name?.split("-")[0]
      .trim() || "";

  const deliveryDateAndTime = formatRealtimeEstimateDate({
    confirmedDeliveryTime: campaignOrder.realtimeEstimate.confirmedDeliveryTime,
    estimatedTimeFrom: campaignOrder.realtimeEstimate.estimatedTimeFrom,
    estimatedTimeTo: campaignOrder.realtimeEstimate.estimatedTimeTo,
    deliveryDate: campaignOrder.deliveryDate,
    showTimePrefix: true,
  });

  const campaignDeliveryDate = campaignOrder.deliveryDate || "";

  const campaignDateTimeDeliveryString = `${formatDate(
    new Date(campaignDeliveryDate),
    dayFormat,
  )} ${intl.TIME_DEFINITIVE_FORM} ${deliveryDateAndTime}
  `;

  return {
    isCampaignOrderPresent: true,
    campaignName,
    campaignDateTimeDeliveryString,
  };
};

const intl = (
  {
    no: {
      TIME_DEFINITIVE_FORM: "",
    },
    se: {
      TIME_DEFINITIVE_FORM: "den",
    },
    dk: {
      TIME_DEFINITIVE_FORM: "",
    },
  } as const
)[language];
